
const baseurl = "https://encryption.edukrypt.app/lmsapi";
const apikey = "41972b904495f193f1be79bcaf5a6099";
const domain = "https://test.com";
const imageBase = "https://encryption.edukrypt.app";


//const baseurl = "http://localhost/saas_encryption_2/lmsapi";
// const apikey = "1a973f53cfa911ca8a4cc5e7b235ab4d";
// const domain = "https://sbaedu.com";


export {
    baseurl,
    apikey,
    domain,
    imageBase
} ;